(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mineralia-stores"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mineralia-stores-filter')) {
    class MineraliaStoresFilter extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.mineralia-stores__card[data-region]'));
        this.toolbar = this.querySelector('[data-stores-toolbar]');
        this.panel = this.querySelector('[data-stores-panel]');
        this.desktop = window.matchMedia('(min-width: 990px)');

        if (this.toolbar) {
          this.buttons = Array.from(this.toolbar.querySelectorAll('[data-region]'));
          this.status = this.toolbar.querySelector('[data-stores-status]');
          this.onFilterClick = this.onFilterClick.bind(this);
          this.toolbar.addEventListener('click', this.onFilterClick);
          this.toolbar.hidden = false;
        }

        if (this.panel) {
          this.onCardClick = this.onCardClick.bind(this);
          this.onMediaChange = this.onMediaChange.bind(this);
          this.addEventListener('click', this.onCardClick);
          this.desktop.addEventListener('change', this.onMediaChange);
          this.onMediaChange();
        }
      }

      disconnectedCallback() {
        this.toolbar?.removeEventListener('click', this.onFilterClick);
        this.removeEventListener('click', this.onCardClick);
        this.desktop?.removeEventListener('change', this.onMediaChange);
        this.observer?.disconnect();
      }

      /**
       * The list + map layout comes from CSS (`.mineralia-stores__layout--map`), so nothing
       * moves when this runs. Desktop only needs to load the shared map once it is in view.
       */
      onMediaChange() {
        if (!this.desktop.matches) return;

        if (!this.activeMap) {
          const active = this.cards.find((card) => card.classList.contains('is-active') && !card.hidden);
          this.select(active || this.firstVisibleCard(), { load: false });
        }

        // Load Google Maps only when the section comes into view.
        if (!this.observer) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.mapReady = true;
              this.loadMap();
            },
            { rootMargin: '200px 0px' }
          );
          this.observer.observe(this.panel);
        }
      }

      firstVisibleCard() {
        return this.cards.find((card) => !card.hidden && card.dataset.storeMap);
      }

      onCardClick(event) {
        if (!this.panel || !this.desktop.matches) return;
        const target = event.target;
        if (!(target instanceof Element)) return;
        // Links (directions, phone, WhatsApp) keep their own behavior.
        if (target.closest('a') || (target.closest('button') && !target.closest('[data-store-select]'))) return;
        const card = target.closest('.mineralia-stores__card');
        if (card && card.dataset.storeMap) this.select(card, { load: true });
      }

      select(card, { load }) {
        if (!card) return;
        this.cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-active', active);
          const button = item.querySelector('[data-store-select]');
          if (button) button.setAttribute('aria-pressed', String(active));
        });

        this.panel.querySelector('[data-panel-title]').textContent = card.dataset.storeTitle || '';
        this.panel.querySelector('[data-panel-address]').textContent = card.dataset.storeAddress || '';
        const directions = this.panel.querySelector('[data-panel-directions]');
        if (directions) directions.href = card.dataset.storeDirections || '#';

        this.activeMap = card.dataset.storeMap;
        this.activeTitle = card.dataset.storeTitle;
        if (load || this.mapReady) this.loadMap();
      }

      loadMap() {
        if (!this.activeMap) return;
        const frame = this.panel.querySelector('[data-panel-frame]');
        let iframe = frame.querySelector('iframe');
        if (iframe && iframe.dataset.src === this.activeMap) return;

        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.loading = 'lazy';
          iframe.referrerPolicy = 'no-referrer-when-downgrade';
          iframe.setAttribute('allowfullscreen', '');
          iframe.addEventListener('load', () => frame.classList.remove('is-loading'));
          frame.appendChild(iframe);
        }

        frame.classList.add('is-loading');
        iframe.title = `Mapa de ${this.activeTitle || 'la sucursal'}`;
        iframe.dataset.src = this.activeMap;
        iframe.src = this.activeMap;
      }

      onFilterClick(event) {
        const button = event.target.closest('button[data-region]');
        if (!button) return;
        const region = button.dataset.region;
        let visible = 0;

        this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.cards.forEach((card) => {
          const show = !region || card.dataset.region === region;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (this.status) {
          this.status.textContent = `${visible} ${visible === 1 ? 'sucursal' : 'sucursales'}`;
        }

        // Keep the map on a store that is still listed.
        if (this.panel && this.desktop.matches) {
          const active = this.cards.find((card) => card.classList.contains('is-active'));
          if (!active || active.hidden) this.select(this.firstVisibleCard(), { load: this.mapReady });
        }
      }
    }

    customElements.define('mineralia-stores-filter', MineraliaStoresFilter);
  }

  if (!customElements.get('mineralia-store-map')) {
    class MineraliaStoreMap extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.mineralia-stores__map-toggle');
        this.frame = this.querySelector('.mineralia-stores__map-frame');
        this.label = this.querySelector('[data-map-label]');
        if (!this.button || !this.frame) return;

        // En móvil y tablet (sin el panel de escritorio) el mapa se ve siempre en la tarjeta y
        // se carga al acercarse a la pantalla. En escritorio queda el botón «Ver mapa».
        if (window.matchMedia('(max-width: 989px)').matches) {
          this.frame.hidden = false;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.load();
              this.observer.disconnect();
            },
            { rootMargin: '600px 0px' }
          );
          this.observer.observe(this.frame);
          return;
        }

        this.onClick = this.toggle.bind(this);
        this.button.addEventListener('click', this.onClick);
        this.button.hidden = false;
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
      }

      load() {
        if (this.frame.querySelector('iframe')) return;
        const iframe = document.createElement('iframe');
        iframe.src = this.dataset.src;
        iframe.title = this.dataset.title || 'Mapa';
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.setAttribute('allowfullscreen', '');
        this.frame.appendChild(iframe);
      }

      toggle() {
        const open = this.button.getAttribute('aria-expanded') !== 'true';

        if (open) this.load();

        this.frame.hidden = !open;
        this.button.setAttribute('aria-expanded', String(open));
        if (this.label) this.label.textContent = open ? 'Ocultar mapa' : 'Ver mapa';
      }
    }

    customElements.define('mineralia-store-map', MineraliaStoreMap);
  }

  } catch(e) { console.error(e); }
})();
})();
